import { Translations } from "./en"

export const ja: Translations = {
  translation: {
    global: {
      // TODO: Update this translation
      emptySubtitle: "有効なデータが見つかりませんでした。",
      loadingProfile: "プロフィールを読み込み中",
      initializingProfileTitle: "お待ちください。",
      initializingProfileSubtitle: "お使いの情報を収集しています。",
      slowConnectionTitle: "読み込み中",
      slowConnectionSubtitle: "お待ちください, 接続が遅いです。",
      loadingResetView: "通話画面をリセット中",
      errors: {
        unauthorized: "このページにアクセスする権限がありません。",
      },
      peopleCount: "{{count}} 人",
      button: {
        add: "追加",
        edit: "編集",
        submit: "Submit",
        save: "保存する",
        update: "更新する",
        login: "ログインする",
        logout: "ログアウト",
        skip: "スキップする",
        accept: "電話する",
        acceptInbound: "電話を受ける",
        endCall: "通話を終了",
        hold: "保留",
        resume: "保留解除",
        mute: "ミュート",
        unmute: "ミュート解除",
        endTask: "確認して次の方へ",
        confirmAndGoNext: "確認して次の方へ",
        confirmAndGoOffline: "確認してオフラインにする",
        call: "電話する",
        addStatus: "ステータスを追加する",
        cancel: "キャンセル",
        loading: "読み込み中",
        savingReport: "レポートを保存中",
        resetPassword: "新しいパスワードを申請する",
        refreshPage: "ページを更新する",
        showMore: "詳しく表示",
        showLess: "閉じる",
        goBack: "戻る",
        close: "閉じる",
        download: "ダウンロード",
        upload: "ファイルをアップロード",
        moreActions: "その他",
        apply: "適用",
        wontCall: "電話しない",
        confirm: "確認",
        confirmAndReturn: "確認して学生詳細に戻る",
        clickToCopy: "クリックしてコピー",
        copied: "コピー完了!",
      },
      search: {
        action: "検索",
        noItemsFound: "検索結果なし",
        selectedValues: "{{count}} 件選択",
      },
      modals: {
        skipTask: {
          title: "本当にスキップしますか？",
          description:
            "通話をスキップすると、この学生は明日の通話リストの後ろに移動します。",
        },
        abandonCallReport: {
          title: "ステータスの更新を中止してもよろしいですか？",
          description: "すべての変更が失われます",
        },
        goOffline: {
          title: "待機中の通話があります",
          submitDescription: "この通話を確認してオフラインにしますか？",
          skipDescription: "この通話をスキップしてオフラインにしますか？",
          callError: "通話中はオフラインにできません。",
        },
        redirect: {
          title: "このページを表示するにはオフラインにする必要があります。",
          description:
            "このページを表示するには、まずオフラインにしてください。",
        },
        microphoneNotShared: {
          title: "マイクを接続してください",
          win: {
            subtitle: "Windowsのみ",
            button: "Windowsのみ",
            text: [
              "タスクバーの右下にあるスピーカーアイコンをクリックする。",
              "「音量ミキサーを開く」をクリックする。",
              "利用可能なオーディオ出力デバイスのリストが表示される。Chromeを含むすべてのシステムサウンドに使用したいデバイスを選択する。",
            ],
          },
          mac: {
            subtitle: "Macのみ",
            button: "Macのみ",
            text: [
              "画面の左上にあるAppleメニューをクリックする。",
              "「システム設定」をクリックする。",
              "「サウンド」をクリックする。",
              "「出力」タブをクリックします。リストから希望のオーディオ出力デバイスを選択する。",
            ],
          },
        },
        browserError: {
          title:
            "お使いのブラウザはサポートされていないため、通話をすることができません。",
          text: [
            "現在のブラウザではCalliopeはサポートされていません。",
            "通話をするには、Google Chrome、Microsoft Edge、またはMozilla Firefoxをご使用ください。",
          ],
        },
        manualCallLeaveConfirm: {
          title: "ページを離れて通話を終了しますか？",
          description:
            "ページを離れることで通話は終了されます。この際、学生のステータスや架電予定は、最新のものが保持されます。",
          confirmation: "本当にこのページを離れますか？",
          submit: "ページを離れ通話を終了",
        },
        manualCallFinisher: {
          title: "未完の作業が検出されました",
          description:
            "未完了の作業が検出されましたので、こちらで整理いたします。",
          submit: "完了",
        },
      },
      datepicker: {
        placeholder: "日付を選択",
        rangePlaceholder: "日付範囲を選択",
        timeLabel: "時間",
        today: "本日",
        thisWeek: "今週",
        last7days: "過去7日間",
        thisMonth: "今月",
        last30days: "過去30日間",
      },
    },
    sidebarMenu: {
      callPanel: "通話履歴",
      campaigns: "案件",
      noCallList: "NGリスト",
      performance: "パフォーマンス",
      users: "スタッフ",
      missedCalls: "不在着信",
    },
    header: {
      // TODO: Review translations
      admin: "管理者",
      agent: "エージェント",
      callCenterManager: "コールセンターマネージャー",
      callCenterManagerAndAgent: "コールセンターマネージャーとエージェント",
      qualityAnalyst: "品質分析者",
      agentSelectOptions: {
        online: "稼働中",
        offline: "オフライン",
        loading: "Initializing",
      },
      language: "言語",
      logout: "ログアウト",
      editProfile: {
        menuItem: "編集",
        title: "プロフィール編集",
        error: "プロフィールの更新に失敗しました。",
      },
      diagnoseIssue: {
        button: "診断ページを開く",
        title: "不具合の診断",
        description:
          "不具合の内容を診断し結果をサポートに送ることで、よりスムーズな対応に繋がります。",
        instruction: {
          title: "診断の方法",
          one: "1. 以下のボタンから診断用のページを開いてください。",
          two: "2. ページがユーザー情報へアクセスするのを許可してください(画像の上部参照)。ここでは、ユーザーの現在地の認識・マイクの使用・カメラの使用の3つを許可する必要があります。",
          three:
            "3. 自動的に診断が開始します。完了したら“Download results”より結果をダウンロードしてください(画像の下部参照)。",
          four: "4. ダウンロードした診断結果ファイルをSlackにてお送りください。",
        },
      },
    },
    campaigns: {
      list: {
        title: "案件",
        name: "案件名",
        studentCount: "学生数",
        studentsToBeCalled: "本日の架電可能学生数",
        status: "ステータス",
        create: "案件を作成",
        warning: {
          phoneNumber: "重複の電話番号",
        },
      },
      search: {
        inactiveInclude: "停止中/終了済みの案件を表示",
      },
      details: {
        viewList: "案件一覧",
        lastUpdate: "最終編集日",
        currentNumbers: "現在の学生数",
        viewStatuses: "ステータス状況を表示",
        exportCSV: {
          action: "ステータス状況をダウンロード",
          loading: "CSVファイルを準備中",
          success: "CSVファイルが準備されました。",
          download: "ダウンロードCSV",
        },
        importCSV: {
          action: "ステータスを追加",
          errorRow: "{{row}}行目: {{message}}",
          errorRowColumn: "{{row}}行目{{column}}列目: {{message}}",
        },
        students: {
          name: "氏名",
          email: "メール",
          contactDate: "更新日時",
          contactCount: "架電回数",
          currentStatus: "架電結果",
          comment: "コメント",
        },
        search: {
          universities: "全ての大学",
          statuses: "全ての架電結果",
        },
        actions: {
          editComment: {
            label: "操作履歴の編集",
            success: "操作履歴を更新しました",
            error: "操作履歴を更新できませんでした",
          },
        },
      },
      edit: {
        breadcrumb: "案件を編集中",
      },
      create: {
        title: "作成を作成",
        breadcrumb: "作成",
        queuePlaceholder: "キューを選択してください",
        errors: {
          MISSING_OUTBOUND_CALLER_NUMBER_ID:
            "アウトバウンドコールの発信者番号を設定してください。",
          INVALID_NAME: "無効なキュー名です。特殊文字は使用できません。",
        },
      },
      statuses: {
        active: { label: "アクティブ" },
        paused: { label: "停止中" },
        closed: { label: "終了済み" },
      },
      actions: {
        resume: "再開する",
        pause: "停止する",
        close: "終了する",
      },
      dialogs: {
        error: "案件のステータスを変更できませんでした。",
        pause: {
          title: "案件を中止する",
          description:
            "このアクションを確認することで、案件に関連するすべての発信が直ちに中止されます。",
          confirm: "本当にこの案件を中止しますか？",
          success: "案件が中止されました。",
        },
        resume: {
          title: "案件を再開する",
          confirm: [
            "この案件を再開してもよろしいですか？",
            "複数の案件が停止・開始処理中の場合、こちらの処理に時間がかかることがあります。",
            "最新の状況を確認するには更新ボタンをクリックしてください。",
          ],
          success: "案件が再開されました。",
        },
        close: {
          title: "案件を終了する",
          description:
            "終了された案件はAmazon Connectから削除されます。今後この案件での架電および案件の再開は出来ません。",
          callHistoryNote:
            "案件に紐づく架電履歴やパフォーマンスは保持され、今後も確認することが出来ます。",
          limitNote:
            "(案件の終了は主にAmazon Connectで作成可能な案件数が上限に達した際にご使用いただく機能です。)",
          confirm: "本当にこの案件を終了しますか？",
          success: "案件が終了されました。",
        },
        statusUpdate: {
          addTitle: "ステータスを追加",
          addButton: "追加する",
          successDescription: "新しいステータス無事に追加しました。",
          failedDescription:
            "エラーによりステータスを追加できませんでした。後でもう一度お試しください。",
        },
      },
      filters: {
        title: "リストを絞り込む",
        add: {
          short: "追加",
          long: "フィルタを追加する",
          smartFilters: "スマートフィルタ",
          basicFilters: "絞り込む",
          manualAdditions: "手動追加",
        },
        shortSummary: "{{count}}の{{label}}",
        channels: {
          label: "チャンネルのQ&A",
          short: "チャンネル",
          placeholder: "チャンネルを選択",
          add: "チャンネルを追加",
          remove: "チャンネルを削除",
          operators: {
            and: "AND",
            or: "OR",
            "except-for": "除外",
          },
          apply: "フィルターを適用",
        },
        university: {
          label: "大学",
          selectedFilters: "{{count}}のフィルター",
          list: "大学リスト",
          group: "大学グループ",
          include: "含む",
          exclude: "除外",
        },
        graduation_year: {
          label: "卒業年度",
        },
        major: {
          label: "学部カテゴリー",
        },
        selected_phone_numbers: {
          label: "電話番号",
          header: "学生を手動で追加",
          explanation:
            "電話番号を入力して、学生を案件に手動追加することができます。",
          details: [
            "複数の学生を一括で追加したい場合、電話番号を改行で区切ってご入力ください。",
            "電話番号は半角英数字でご入力ください (ハイフン有り/無しどちらでも可)。",
          ],
          submit: "プレビューに進む",
          errors: {
            DUPLICATE: "重複する電話番号",
            INVALID_PHONE_NUMBER: "無効な電話番号",
            NOT_FOUND: "電話番号が見つかりません",
          },
          preview: {
            header: "入力内容のプレビュー",
            noStudentsFound: "No students found!",
            found: "人の学生が案件に追加されます",
            errors: "件のエラーがあります (※エラー項目は案件に反映されません)",
            onlyErrors: "エラーのみ表示",
          },
        },
        department_group: {
          label: "学部",
        },
        gender: {
          label: "性別",
        },
        selected: "{{count}}の{{propertyName}}を絞込み中",
        question: {
          placeholder: "質問を選択",
        },
        answer: {
          placeholder: "答えを選択",
        },
        noFilterSelected: "特になし",
        success: "案件が保存されました。",
      },
      priorityFilters: {
        title: "リストの優先順位",
        warningNoFilters: "使用不可,フィルターを追加してください。",
      },
      preview: {
        table: {
          title: "現在{{count}}人に絞り込み中",
          noResults: "絞り込み結果なし",
          lastName: "姓",
          firstName: "名",
          phoneNumber: "携帯番号",
          channels: "チャンネルのQ&A",
          university: "大学",
          department: "学部",
          major: "学部カテゴリー",
          graduationYear: "卒業年度",
          gender: "性別",
          limitExceed: {
            title:
              "案件に追加できる学生数の上限（{{count}}人）を超えています。",
            description: "絞り込みを変更して人数を減らしてください。",
          },
        },
        emptyState: "フィルタを追加して生徒リストを取得",
      },
    },
    entries: {
      title: "エントリー管理",
      upload: {
        title: "複数結果を追加",
        panelTitle: "複数の結果を追加するには、以下の手順に従ってください：",
        instruction1: "以下のファイルをダウンロードする：",
        instruction2: "次の手順に従って、追加するファイルを編集する：",
        stepText1: "学生の電話番号を入力   ",
        stepText2: "以下からのエントリの結果を入力:",
        instruction3: "編集したファイルを入力欄に追加する：",
        noFilePlaceholder: "ファイルがありません",
        uploadButtonText: "ファイルを添付",
        cancelButtonText: "キャンセルして一覧に戻る",
        confirmButtonText: "ファイルを確認",
        modal: {
          errorTitle: "エラーが見つかりました ({{count}})",
          successTitle: "エラー無し！",
          successDescription:
            "{{count}}件のエントリー結果が更新されました。学生情報の更新を確認するには、学生情報リストに進んでください。",
        },
      },
    },
    performance: {
      export: {
        csvDownload: "CSVダウンロード",
        confirmTitle: "ダウンロードする前に確認すること",
        dateSelectText: "ダウンロード可能な日付",
        campaignConfirmText: "選択されたキャンペーン",
        allCampaigns: "全てのキャンペーンをダウンロード",
        note: "注意",
        noteText:
          "ダウンロードされるキャンペーンデータには以下のものが含まれます：",
        downloadRequestButton: "ダウンロード準備する",
        downloadButton: "ダウンロードする",
        loadingTitle: "ダウンロード準備中",
        loadingDescription:
          "CVSをダウンロードできるように準備しますので、しばらくお待ちください。",
        successTitle: "CSVダウンロード可能",
        successDescription:
          "下のボタンをクリックしてCSVをダウンロードしてください。",
      },
      tabs: {
        campaign: "案件",
        staff: "スタッフ",
        personal: "個人",
      },
      placeholder: {
        search: "検索",
      },
      table: {
        cacheTips: "データ更新日時: {{time}} / 5分ごとに自動更新",
        campaignName: "案件名",
        agentName: "氏名",
        deletedUser: "[削除されたユーザー]",
      },
      detail: {
        agentTitle: "スタッフのパフォーマンス",
        campaignTitle: "案件詳細",
        callsPerHour: "時間当たりのコール数",
        creditForEntryConfirmedCVR: "エントリー確定 / 代理エントリー確定",
        totalProcessingTime: "総処理時間",
      },
      error: {
        invalidFormat: "データの表示に問題がありました",
      },
    },
    syncAgents: {
      description:
        "Amazon connectのデータベースと同期してスタッフ情報を更新するには、下のボタンをクリックしてください。",
      buttonText: "スタッフ更新",
      syncing: "更新中",
      success: "スタッフが更新されました。",
      error: "更新できませんでした。",
      latestUpdateAt: "最終更新日: {{date}}",
    },
    users: {
      list: {
        name: "氏名",
        email: "メールアドレス",
        role: "権限",
        queues: "担当案件",
        status: "ステータス",
        createdAt: "作成日",
        updatedAt: "最終更新日",
        missingRole: {
          label: "権限なし",
          tooltip:
            "権限が未設定です。「スタッフ更新」を実行して割り当ててください。",
        },
      },
      statuses: {
        CONFIRMED: "有効",
        FORCE_CHANGE_PASSWORD: "パスワード要変更",
        RESET_REQUIRED: "パスワード要変更",
        NOT_FOUND: "未同期",
        DELETED: "削除済み",
      },
      groups: {
        Agent: "スタッフ",
        Manager: "管理者",
      },
      edit: {
        title: "スタッフの編集",
        routingProfile: "ルーティングプロファイル（担当案件）",
        success: "ユーザー{{name}}が正常に更新されました。",
      },
      resendPassword: {
        action: "パスワードを再送信",
        confirm: "以下のメールアドレスにパスワードを再送信しますか？",
        success: "一時的なパスワードを {{email}} にお送りしました。",
      },
    },
    dashboard: {
      title: "単位詳細",
      tabs: {
        performance: "パフォーマンス単位",
        statuses: "ステータス単位",
      },
      csv: {
        exportAction: "エクスポートCSV",
        exportLoading: "CSVファイルを準備中",
        downloadAction: "ダウンロードCSV",
      },
      selectOptions: {
        values: {
          allStaff: "全員スタッフ単位",
        },
        labels: {
          staffPerformance: "スタッフ単位",
          campaignPerformance: "案件単位",
        },
        searchPlaceholder: "検索",
        selectPlaceholder: "選択する",
      },
      table: {
        header: {
          lastName: "姓",
          firstName: "名",
          numberOfCalls: "コール数",
          connectedCalls: "通電数",
          entries: "エントリー数",
          actualEntries: "実エントリー数",
          login: "ログイン",
          ringTime: "呼び出し時間",
          talkTime: "通話時間",
          operation: "処理時間",
          grandTotal: "総計",
          totalNumber: "総数",
          totalTime: "総時間",
          hourly: "時間当り",
          average: "平均",
          rate: "率",
        },
        values: {
          hours: "時間",
        },
      },
    },
    ids: {
      taskId: "タスクID:",
      voiceId: "音声ID:",
      uuid: "UUID:",
    },
    callPanel: {
      title: "学生情報",
      incomingCall: "電話着信",
      loading: {
        waitingForTask: "次の架電を準備中",
        fetchingData: "データを取得中",
        inboundCall: "インバウンドコールの読み込み中",
        interruptedByInboundCall: [
          "先ほどの学生は",
          "このインバウンドコールの後に再度表示されます",
        ],
      },
      emptyQueue: {
        subtitle: "お疲れさま！",
        cardTitle: "本日の架電業務は終わりました。",
        cardText:
          "パソコンの電源を切る前に、自身ステータスをオフラインにしてください。",
      },
      resetState: {
        title: "予期せぬエラーが発生しました",
        subtitle: "続けるにはページを更新してください。",
      },
      invalidAgentConfig: {
        title: "案件が見つかりませんでした",
        description: [
          "あなたに割り当てられた案件を見つけることができませんでした。",
          "マネージャーに連絡し、担当案件の設定を再度行うよう依頼してください。",
        ],
      },
      status: {
        connecting: "接続中",
        error: "接続エラー",
        // TODO: Improve these translations
        missedCall: "不在着信",
        missedCallAgentState: "通話接続の問題：ネットワークまたはマイク",
        missedTask: "タスクを逃した",
        rejectedCall: "通話拒否",
        connected: "接続済み",
        acw: "通話結果を入力中",
        skipped: "スキップしました",
      },
      report: {
        title: "ステータスを入力中",
      },
      phoneNumber: "電話番号",
      reason: {
        invalidQueueARN:
          "システムの設定エラーのため、この学生に架電することはできません。",
        disabledCampaign:
          "案件が停止中のため、この学生に電話をかけることは出来ません。",
      },
      idle: {
        heading: "一定時間操作がなかったため稼働を停止しました",
        body: [
          "{{minutes}}分以上操作がなかったため稼働を一時的に停止しました。この間に経過した時間は処理時間としてカウントされません。",
          "業務に戻るには「稼働を再開する」をクリックしてください。",
        ],
        button: "稼働を再開する",
      },
      callErrorCard: {
        networkError: {
          title: "ネットワークエラー",
          description: [
            "ネットワークエラーが発生しました。",
            "しばらくしても直らない場合以下の解決策をお試しください：",
            ["ページの更新", "ブラウザの再起動", "PCの再起動"],
            "それでも解決しない場合、以下のボタンからページを強制更新してください。",
            "強制更新をすると入力した通話結果が失われるのでご注意ください。",
          ],
        },
        browserError: {
          title: "ブラウザがサポートされていません",
          description: [
            "現在のブラウザではCalliopeはサポートされていません。",
            "通話をするには、Google Chrome、Microsoft Edge、またはMozilla Firefoxをご使用ください。",
          ],
        },
        micPermissionError: {
          title: "マイクの接続エラー",
          description: ["架電を続けるにはマイクをPCに接続してください。"],
          button: "設定方法を確認する",
        },
        unexpectedError: {
          title: "不明なエラー",
          description: [
            "不明なエラーが発生しました。",
            "しばらくしても直らない場合以下の解決策をお試しください：",
            ["ページの更新", "ブラウザの再起動", "PCの再起動"],
          ],
        },
        missedCallNetworkError: {
          title: "接続エラー",
          description: [
            "接続エラーが発生したため通話を終了しました。",
            "通話結果を入力し保存するか、「前の画面に戻る」から1つ前の画面に戻り再架電してください。",
          ],
        },
        submitError: {
          title: "次の通話に切り替えることができませんでした。",
          description:
            "再度お試しいただき、再発する場合はページをリロードしてください。",
        },
      },
      reportErrorCard: {
        scheduledCallDateTimeTooSmall: {
          title: "無効な通話レポート日付",
          description: [
            "通話レポートの日付と時刻が過去に遡りすぎています。",
            "正しい日付と時刻を設定してください。",
          ],
        },
        scheduledCallDateTimeTooBig: {
          title: "無効な通話レポート日付",
          description: [
            "通話レポートの日付と時刻が未来に進みすぎています。",
            "正しい日付と時刻を設定してください。",
          ],
        },
        otherValidationError: {
          title: "通話レポートデータの検証エラー",
          description: [
            "提出された通話レポートのデータが無効です。",
            "フォームデータを確認して再試行してください。",
          ],
        },
      },
    },
    caseHistory: {
      entorId: "エンターID",
      legacyId: "旧エンターID",
      nameFurigana: "ふりがな",
      university: "大学",
      department: "学部",
      graduation: "卒業年",
      question: "学生時代に力をいれたこと",
      agent: "エージェント",
      campaign: "案件",
      callStatus: "通話状況",
      agentName: "架電スタッフ名",
      contactHistory: "全案件の通話履歴",
      email: "E-メール",
      hiddenStatus: {
        scheduled: "未架電",
        renewed: "再架電",
        recovery: "リカバリー",
      },
      applicationDate: "応募日",
      applicationRoute: "応募経路",
      syncQA: "Q&A同期",
      refreshUpdated: "学生の質問と回答を更新しました",
      refreshUpToDate: "学生の質問と回答はすでに最新です",
      refreshError: "Q&Aデータの更新に失敗しました",
      tabs: {
        history: "履歴",
        numberOfItems: "回数{{count}}",
        detailedInformation: "詳細情報",
      },
      activityFeed: {
        staff: "スタッフ名",
        comments: "メモ",
        lastUpdate: "更新日時",
        nextCall: "次回通話予定",
        status: "ステータス",
        callType: {
          label: "操作タイプ",
          values: {
            noCall: "通話なしの追加",
            outbound: "アウトバウンド通話",
            inbound: "インバウンド通話",
          },
        },
      },
    },
    sidePanelMetrics: {
      open: "本日の架電状況",
      description: [
        "データは現在の担当案件のみをもとに表示されています。",
        "現在あなたが担当している案件のリストはこちらです：",
      ],
      title: ["本日の", "架電状況"],
      callsPerHour: "コール数/h",
      connectedCalls: {
        perHour: "通電数/h",
        rate: "通電率",
      },
      conversions: {
        total: "CV数",
        rate: "CVR",
      },
      entries: {
        total: "見込みCV数",
        rate: "見込みCVR",
      },
    },
    callResult: {
      title: "通話結果",
      status: "ステータス",
      reason: "理由",
      scheduleCall: "再架電を予約する",
      memo: "メモ",
      placeholder: "テキスト入力",
      success: "通話結果を送信しました。",
      pcrTitle: "ステータスの更新",
      groups: {
        out: "アウト",
        callAgain: "再架電",
      },
    },
    callHistory: {
      heading: "通話履歴",
      searchPlaceholder: "氏名で検索",
      agentsFilterPlaceholder: "全ての架電スタッフ",
      campaignsFilterPlaceholder: "全ての案件",
      tabs: {
        myCalls: "自分の架電",
        allCalls: "全スタッフの架電",
      },
      duration: "長さ",
      recording: {
        transcript: {
          title: "文字起こし",
          toggle: "文字起こし",
          autoScroll: "自動スクロール",
        },
        retrieveFailure:
          "音声録音の処理には時間がかかる場合があります。後でもう一度お試しください。",
      },
      role: {
        agent: "架電スタッフ",
        student: "学生",
      },
    },
    missedCalls: {
      heading: "不在着信",
      subHeading:
        "自分が過去に架電したことのある案件に対する、直近2週間の未対応の不在着信を表示します。",
      filterPlaceholder: "全ての案件",
      cellHeading: {
        name: "氏名",
        entorId: "エンターID",
        legacyId: "旧エンターID",
        status: "ステータス",
        updatedAt: "更新日時",
        campaign: "案件",
        memo: "メモ",
      },
      emptyState: "不在着信はありません。",
      dataLoadingError: "不在着信データの読み込みに失敗しました。",
    },
    login: {
      emailLabel: "メールアドレス",
      emailPlaceholder: "name@domain.com",
      passwordLabel: "パスワード",
      passwordPlaceholder: "パスワード入力",
      subtitle: "アカウントにログインする",
      help: "ヘルプが必要ですか？",
      contactManager: "マネージャーまでお問い合わせください。",
      forgotPassword: "パスワードをお忘れですか？",
      loadingText: "情報の確認中",
    },
    resetPassword: {
      request: {
        title: "パスワードをお忘れですか？",
        subtitle:
          "以下のフォームにメールアドレスを入力してください。パスワードをリセットするためのリンクがメールアドレスに送信されます。",
        loadingText: "情報の確認中",
        success:
          "パスワードをリセットするための手順が記載されたメールが送信されました。",
        tryAgain: "メールが届かない場合",
      },
      confirm: {
        title: "新しいパスワードを設定",
        subtitle: "以下のルールに従ってパスワードを設定してください。",
        bulletPoints: [
          "パスワードは8文字以上",
          "アルファベットで大文字と小文字使用すること",
          "スペースは使用しないこと",
          "以下の文字の少なくとも1種類を含む",
        ],
        subBulletPoints: ["数字", "特殊文字"],
        confirmPasswordLabel: "パスワード (確認用)",
        loadingText: "情報の確認中",
        success: "パスワードが正常にリセットされました。",
      },
    },
    updateCheckerNotification: {
      title: "新しいバージョンが利用可能です。",
      description: "ページをリロードするには更新ボタンをクリックしてください。",
      ignore: "後で",
      update: "今すぐ更新",
    },
    noCallList: {
      columns: {
        actions: "操作",
        updatedAt: "更新日時",
      },
      removeStudent: {
        confirmTitle: "NGリストから削除",
        confirmDescription:
          "この学生をNGリストから削除してもよろしいですか？削除すると、再び連絡可能になります。",
        confirmAction: "削除",
        cancel: "キャンセル",
        error: "NGリストから学生を削除できませんでした。",
        success: "NGリストから学生を削除しました。",
        warnings: {
          TASK_NOT_FOUND:
            "NGリストから学生を削除しましたが、この学生の予約タスクが見つかりませんでした",
          CASE_NOT_FOUND:
            "NGリストから学生を削除しましたが、この学生のケースが見つかりませんでした",
          INTERNAL_ERROR:
            "NGリストから学生を削除しましたが、システムエラーのため関連レコードを更新できませんでした",
        },
      },
      importCSV: {
        action: "CSVで一括更新",
        intro: "NGリストを一括で更新するには、以下の手順に従ってください：",
        step1: "以下のファイルをダウンロードする：",
        step2: "追加するファイルを編集する：",
        details: [
          "学生の電話番号、Emailを入力",
          "NGリストに追加したい学生のNo CallカラムにTRUEと入力",
          "NGリストから削除したい学生のNo CallカラムにFALSEと入力",
        ],
        step3: "結果を確認する",
        explanations:
          "選択を確定すると、システムはファイルにエラーがないかチェックし、NGリストを一括更新していきます。",
        globalError: "ファイル{{filename}}のアップロードに失敗しました",
        warnings: {
          STUDENT_NOT_FOUND: "学生が見つかりません",
          TASK_NOT_FOUND: "この学生の予約タスクが見つかりませんでした",
          CASE_NOT_FOUND: "この学生のケースが見つかりませんでした",
          INTERNAL_ERROR:
            "システムエラーのため、この学生のNGリストを更新できませんでした",
          INVALID_CSV: "無効なCSVファイルです。",
          PHONE_NUMBER_INVALID: "無効な電話番号",
          PHONE_NUMBER_DUPLICATE: "重複する電話番号",
          EMAIL_INVALID: "無効なメールアドレス",
          NO_CALL_REQUIRED: "No callの値は必須です",
          NO_CALL_INVALID:
            "No callの値が無効です。True または False を入力してください",
          PHONE_OR_EMAIL_REQUIRED: "電話番号またはメールアドレスが必要です",
          EMAIL_DUPLICATE: "ファイル内でメールアドレスが重複しています",
          SERVER_CHECK_FAILED:
            "サーバーチェックに失敗しました。もう一度お試しください。",
          WRITE_FAILED: "この学生の更新に失敗しました",
        },
        formatCard: {
          title: "CSVフォーマット",
          description:
            "以下のフィールドを含むCSVをアップロードしてください。各行には電話番号またはメールアドレスの少なくとも1つが必要です。",
          downloadTemplate: "テンプレートをダウンロード",
        },
        noCallAction: {
          add: "追加",
          remove: "削除",
        },
        columns: {
          row: "行",
          phone: "電話番号",
          email: "メールアドレス",
          noCall: "No call",
          status: "ステータス",
          details: "詳細",
        },
        status: {
          ready: "準備完了",
          no_change: "変更なし",
          not_found: "見つかりません",
          invalid: "無効",
          success: "完了",
          error: "エラー",
        },
        preview: {
          readyCount: "{{count}}件の学生を処理できます",
          errorCount: "{{count}}件のエラーがあります",
          downloadErrors: "エラーをダウンロード",
          processButton: "処理する",
        },
        checking: {
          progress: "{{total}}件中{{completed}}件を確認中...",
        },
        importing: {
          progress: "{{total}}件中{{completed}}件を処理中...",
          complete: "インポート完了",
          summary: "{{success}}件の学生が更新されました、{{errors}}件のエラー",
          importAnother: "別のファイルをインポート",
        },
      },
    },
    errors: {
      errorPage: {
        goBack: "calliope.co.jpに戻る",
        notFoundError: "ページが見つかりませんでした",
        notFoundDescription: "お探しのページは見つかりませんでした。",
        unexpectedError: "予期せぬエラーが発生しました。",
        unexpectedErrorDescription: "ログアウトして再度ログインしてください。",
      },
      form: {
        required: "{{fieldName}}を入力してください。",
        wrongDate: "正しい日程を選択してください",
        unknown: "この{{fieldName}}は使用できません。",
        validStartDateTime:
          "{{fieldName}}は未来の日時を設定する必要があります。",
        scheduledCallDateTimeWithinBounds:
          "{{fieldName}} は未来の{{months}}ヶ月以内である必要があります。",
      },
      login: {
        passwordFormat: "パスワードの形式が正しくありません。",
        emailFormat: "メールアドレスの形式が正しくありません。",
        userNotFoundOrUnauthorized:
          "ユーザー名またはパスワードが正しくありません。",
        unknownError: "エラーが発生しました!",
        passwordAttemptsExceeded: "パスワード試行回数が超過しました。",
      },
      resetPassword: {
        unknownErrorRequest: "パスワードをリセットできませんでした。",
        unknownErrorConfirm: ["パスワードをリセットできませんでした。"],
        LimitExceededException: "パスワードリセットの試行回数を超過しました。",
        UserNotFoundException: "メールが見つかりません",
        NotAuthorizedException:
          "権限がありません。マネージャー/サポートチームにお問い合わせください。",
        mismatchingPassword: "パスワードが一致しません。",
        notAuthorized: [
          "パスワードをリセットする権限がありません",
          "マネージャー/サポートチームにお問い合わせください。",
        ],
        expiredCode: [
          "セキュリティのため、このパスワードリセットリンクの有効期限が切れています",
          "ログインページに戻り、新しいパスワードリセットリンクを申請してください。",
        ],
        codeMismatch: [
          "無効なリセットコードです",
          "古いメールを開いているか、コードの入力ミスの可能性があります。受信トレイで最新のメール（数分以内に送信）を確認して、再度お試しください。",
        ],
        userNotFound: [
          "このメールアドレスのアカウントが見つかりませんでした",
          "入力したメールアドレスが正しいかご確認ください。または、マネージャー/サポートチームにサポートを依頼してください。",
        ],
      },
      callPanel: {
        nextContactError: "次の通話に切り替えることができませんでした。",
        callError: "通話を開始できませんでした。",
        answerCallError: "通話に応答できませんでした。",
        skipCallError: "通話をスキップできませんでした。",
        endCallError: "通話を終了できませんでした。",
        resumeCallError: "通話を再開できませんでした。",
        holdCallError: "通話を保留できませんでした。",
        muteCallError: "通話をミュートできませんでした。",
        unmuteCallError: "通話のミュートを解除できませんでした。",
        statusUpdateError: "ステータスを追加できませんでした。",
      },
      callResult: {
        submitError: "通話結果を送信できませんでした。",
      },
    },
  },
} as const
